import { tState } from "@src/Model/Model"
import { Locale } from "@zeguro/schema-validator/dist/types/coco/core/combined"
import { format } from "date-fns"
import { enCA, enUS, frCA } from "date-fns/locale"
import { formatInTimeZone } from "date-fns-tz"
import { useCallback } from "react"
import { useSelector } from "react-redux"

export enum DateFormat {
  Time = "time",
  Date = "date",
  DateTime = "datetime",
}

function getFnsDateFormat(dateFormat: DateFormat) {
  switch (dateFormat) {
    case DateFormat.Time:
      return "p"
    case DateFormat.Date:
      return "PP"
    case DateFormat.DateTime:
      return "PP p"
  }
}

function getFnsLocale(locale: Locale) {
  switch (locale) {
    case "en-US":
      return enUS
    case "en-CA":
      return enCA
    case "fr-CA":
      return frCA
    default:
      return enUS
  }
}

function formatDateByLocale(
  date: Date,
  locale?: Locale,
  dateFormat: DateFormat = DateFormat.DateTime,
) {
  return format(date, getFnsDateFormat(dateFormat), {
    locale: getFnsLocale(locale),
  })
}

export function useUserLocaleDateFormatting() {
  const userProfile = useSelector((state: tState) => state.portal.userProfile)

  const formatDate = useCallback(
    (date: Date, dateFormat: DateFormat = DateFormat.DateTime) => {
      return formatDateByLocale(date, userProfile.locale, dateFormat)
    },
    [userProfile.locale],
  )

  const formatDatePST = (date: string, dateFormat: DateFormat) => {
    return new Date(date).toString() !== "Invalid Date"
      ? formatInTimeZone(
          new Date(date),
          "America/Los_Angeles",
          getFnsDateFormat(dateFormat),
          {
            locale: getFnsLocale(userProfile.locale),
          },
        )
      : "Invalid Date"
  }

  return { formatDate, formatDatePST }
}
